import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/tmp/gatsby/src/components/layout.js";
import SEO from '../components/seo.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEO title="Data Privacy" slug="en/data-privacy/" lang="en" mdxType="SEO" />
    <h1>{`Data Privacy`}</h1>
    <p>{`We attach great importance to the protection of your data. In order to fully inform you about the use of personal data, we ask you to take note of the following data protection information.`}</p>
    <h3>{`Personal data`}</h3>
    <p>{`Personal data that you transmit electronically on this website, such as name, email address, address or other personal information, will only be used by us for the specified purpose, will be kept safe and will not be passed on to third parties without consent. The provider automatically collects and saves information on the web server such as the browser used, operating system, referring page, IP address, time of access, etc. This data cannot be assigned to a specific person without checking other data sources and we do not further evaluate this data as long as it is not illegal Use of our website.`}</p>
    <h3>{`Cookies & Tracking`}</h3>
    <p>{`This website does NOT use cookies or other storage devices to identify and record user behavior.`}</p>
    <p>{`You can deactivate tracking in your browser at any time using the `}<inlineCode parentName="p">{`Do Not Track (DNT)`}</inlineCode>{` option.`}</p>
    <h3>{`Google Analytics`}</h3>
    <p>{`Our website uses functions of the web analysis service Google Analytics, which is offered by Google LLC, 1600 Amphitheater Parkway Mountain View, CA 94043, USA (“Google”).`}</p>
    <p><strong parentName="p">{`The option for identification by cookie is deactivated.`}</strong></p>
    <p>{`The information about your use of this website (including your IP address and the URLs of the websites accessed and the attributes of the website) are transmitted to and stored by Google on servers in the United States.`}</p>
    <p>{`The data obtained in this way is used to optimize the use of the website.`}</p>
    <p>{`Our website uses the IP anonymization option offered by Google Analytics. Your IP address will therefore be shortened / anonymized by Google as soon as Google receives your IP address. On our behalf, Google will use this information to evaluate your use of the website, to compile reports on website activity and to provide us with other services relating to website activity and internet usage. The IP address transmitted by your browser as part of Google Analytics will not be merged with other data by Google.`}</p>
    <p>{`» More information on the `}<a parentName="p" {...{
        "href": "https://www.google.com/analytics/terms/de.html"
      }}>{`Google Terms of Use`}</a>{` and `}<a parentName="p" {...{
        "href": "https://www.google.at/intl/at/policies/"
      }}>{`Google's privacy policy`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      